"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const mobx_react_1 = require("mobx-react");
require("./index.scss");
const react_router_dom_1 = require("react-router-dom");
const react_helmet_1 = __importDefault(require("react-helmet"));
const contexts_1 = require("@App/contexts");
const LoginForm_1 = __importDefault(require("@Scenes/LoginScene/LoginForm"));
const analytics_utils_1 = require("@App/common/utils/analytics-utils");
const navigation_1 = __importDefault(require("@App/navigation"));
const react_sdk_1 = require("@openfeature/react-sdk");
const LoginScene = () => {
    const { userStore, createPasswordStore, authStore, uiStore, popupStore, preloaderStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const navigate = (0, react_router_dom_1.useNavigate)();
    const location = (0, react_router_dom_1.useLocation)();
    const [isFirstStepDone, setFirstStepDone] = (0, react_1.useState)(false);
    const [mfaType, setMfaType] = (0, react_1.useState)('');
    const [mfaContactPoint, setMfaContactPoint] = (0, react_1.useState)('');
    const { value: allowNewUserSceneRedirect } = (0, react_sdk_1.useFlag)('member-songwriter-signup-rework', false);
    const loginFunc = (loginFormData) => __awaiter(void 0, void 0, void 0, function* () {
        preloaderStore.openMainPreloader(true);
        authStore
            .login(loginFormData.username, loginFormData.password)
            .then((result) => {
            if (result.mfaType === 'email' || result.mfaType === 'sms') {
                setFirstStepDone(true);
                setMfaType(result.mfaType);
                setMfaContactPoint(result.mfaContactPoint);
            }
            if (result.message === 'enroll_mfa') {
                popupStore.setAlertData('Before logging in, you must enroll in two factor authentication.', true);
                createPasswordStore.getValue(loginFormData.password, 'password');
                createPasswordStore.setEnrollMfaEmail(loginFormData.username);
                navigate('/enroll-mfa');
            }
        })
            .finally(() => {
            (0, analytics_utils_1.analyticsSendIdentify)(userStore.userInfo);
            preloaderStore.openMainPreloader(false);
            const userSettings = userStore.userSettings;
            if (!(userSettings && 'showWelcomePopup' in userSettings && !userSettings.showWelcomePopup) &&
                allowNewUserSceneRedirect) {
                return navigate(navigation_1.default.newUser.root());
            }
            if (authStore.isLoggedIn) {
                return navigate('/');
            }
            return;
        });
    });
    const mfaFunc = (loginFormData) => __awaiter(void 0, void 0, void 0, function* () {
        // loginFormData.code should always exist here, but is technically optional.
        if (loginFormData.code) {
            preloaderStore.openMainPreloader(true);
            try {
                yield authStore.mfaSubmit(loginFormData.code);
                (0, analytics_utils_1.analyticsSendIdentify)(userStore.userInfo);
                navigate('/');
            }
            catch (ignore) {
                setFirstStepDone(false);
                popupStore.setAlertData('An error occurred trying to login you. Please contact support', true);
            }
            finally {
                preloaderStore.openMainPreloader(false);
            }
        }
    });
    const handleInactiveMessage = () => location.search === '?inactive' &&
        popupStore.setAlertData("Due to inactivity, you've been logged out. Thank you for visiting the MLC Portal!", false);
    (0, react_1.useEffect)(() => {
        (0, analytics_utils_1.analyticsSendPage)('login');
        handleInactiveMessage();
        uiStore.setOnLoginPage(true);
        return () => {
            popupStore.setAlertData('', true);
        };
    }, []);
    return authStore.isLoggedIn ? (react_1.default.createElement(react_router_dom_1.Navigate, { to: '/' })) : (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_helmet_1.default, { title: 'Login' }),
        react_1.default.createElement("main", { className: 'login-scene' },
            react_1.default.createElement("div", { className: 'global-container' },
                react_1.default.createElement(LoginForm_1.default, { mfaFunc: mfaFunc, loginFunc: loginFunc, isFirstStepDone: isFirstStepDone, mfaType: mfaType, mfaContactPoint: mfaContactPoint })))));
};
exports.default = (0, mobx_react_1.observer)(LoginScene);
